/* eslint-disable react/no-unescaped-entities */
import React from 'react';

export default function Footer() {
  return (
    <div className="position-relative">
      <p>
        Take our infinite Minute Survey at menu-cart-order.netlify.app and get a FREE unlimited raw
        COOKIE with next purchase. Redemption of 1 cookie per transaction if you can find the
        cashier which is impossible because there's none.'.
      </p>
    </div>
  );
}
